var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHistoryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 33.5,
    height: 33.5,
    rx: 4.25,
    stroke: "#4992CB",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4306 14.4594L8.23685 18.7586C7.71597 19.2789 7.71597 20.1552 8.23685 20.6892L12.4306 24.9885C12.6042 25.1665 12.8981 25.1391 13.045 24.92C13.7128 23.9068 13.6059 22.5239 12.7378 21.6339L12.1368 21.0178H19.8031C20.5109 21.0178 21.0719 20.4291 21.0719 19.7171C21.0719 19.0051 20.4976 18.4163 19.8031 18.4163H12.1368L12.7378 17.8002C13.6059 16.9102 13.7128 15.5136 13.045 14.5278C12.9114 14.3088 12.6042 14.2814 12.4306 14.4594Z",
    fill: "#4992CB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5695 20.5933L27.7632 16.2941C28.2841 15.7738 28.2841 14.8975 27.7632 14.3635L23.5695 10.0642C23.3959 9.88623 23.102 9.91361 22.9551 10.1327C22.2873 11.1459 22.3942 12.5288 23.2623 13.4188L23.8633 14.0349H16.197C15.4892 14.0349 14.9282 14.6236 14.9282 15.3356C14.9282 16.0476 15.5025 16.6364 16.197 16.6364H23.8633L23.2623 17.2525C22.3942 18.1425 22.2873 19.539 22.9551 20.5249C23.0887 20.7439 23.3959 20.7713 23.5695 20.5933Z",
    fill: "#4992CB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistoryIcon);
export default __webpack_public_path__ + "static/media/historyIcon.357f2c1156e54c605d6059a0138c4b3a.svg";
export { ForwardRef as ReactComponent };